module.exports = __webpack_public_path__ + "img/coinmarketcap.087f45ff.jpeg";